import React, { useEffect, useState } from 'react'
import { Team } from './firm/mapper'
import TeamTemplate from './team/teamTemplate'

type TeamsProps = {
  teams: Team[] | null
  youTubeApiKey: string | null
}

const Teams: React.FC<TeamsProps> = ({ teams, youTubeApiKey }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [entries, setEntries] = useState<
    { title: string | null; content: Team }[] | null
  >(null)

  useEffect(() => {
    const array = teams?.map((team) => ({
      title: team?.name ?? null,
      content: team,
    }))
    setActiveTab(array?.[0]?.title || null)
    setEntries(array || null)
    setIsLoaded(true)
  }, [])

  const [activeTab, setActiveTab] = React.useState<string | null>(
    entries?.[0]?.title || null,
  )

  const handleTabClick = (title: string | null) => {
    setActiveTab(title)
  }

  return (
    <div>
      {isLoaded && (
        <div>
          <div className="flex flex-wrap gap-2 lg:justify-start justify-center">
            {entries?.map(({ title }) => (
              <button
                type="button"
                key={`team-${title}`}
                onClick={() => handleTabClick(title)}
                className={`text-sm font-medium border-2 border-primary rounded-md px-4 py-2 transition-colors duration-300 ease-in-out ${
                  activeTab === title
                    ? 'bg-white text-primary'
                    : 'bg-primary text-white'
                }`}
              >
                {title ?? 'Equipe'}
              </button>
            ))}
          </div>
          <div>
            {entries?.map(({ title, content }) => (
              <div key={`content ${title}`}>
                {activeTab === title && (
                  <TeamTemplate
                    team={content}
                    youTubeApiKey={youTubeApiKey}
                    color={null}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Teams
